export enum LogLevel {
  Trace = 1000,
  Debug = 2000,
  Information = 3000,
  Warning = 4000,
  Error = 5000,
  Fatal = 6000,
}
